import React from 'react';
import Head from 'next/head';
import classNames from 'classnames';
import { ProspectForm } from '../ProspectForm';
import { Navbar } from '../Navbar';
import { Information } from '../Information';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Reserve = function Reserve(_ref) {
  var emailSent = _ref.emailSent,
      submitProspect = _ref.submitProspect,
      feedback = _ref.feedback,
      handleFeedback = _ref.handleFeedback;
  return /*#__PURE__*/_jsxs("div", {
    className: "fit mx-auto h-fill flex flex-column max-w-full lg:max-w-screen-xl lg:mx-auto",
    children: [/*#__PURE__*/_jsx(Navbar, {
      brandProps: {
        // eslint-disable-next-line
        onClick: function onClick() {}
      },
      links: [{
        name: 'twitter',
        type: 'icon',
        classes: 'c-beige clickable ml2 h3 display-none'
      }, {
        name: 'instagram',
        type: 'icon',
        classes: 'c-beige clickable ml2 h3 display-none'
      }]
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames('fit flex flex-auto overflow-auto prospect-container', {
        'md:flex-column-reverse': emailSent
      }),
      children: [/*#__PURE__*/_jsxs(Head, {
        children: [/*#__PURE__*/_jsx("title", {
          children: "Subkit"
        }), /*#__PURE__*/_jsx("meta", {
          name: "description",
          content: "Turn your one day into day one."
        }), /*#__PURE__*/_jsx("meta", {
          property: "og:site_name",
          content: "Subkit"
        }), /*#__PURE__*/_jsx("meta", {
          property: "og:type",
          content: "website"
        }), /*#__PURE__*/_jsx("meta", {
          property: "og:title",
          content: "Subkit"
        }), /*#__PURE__*/_jsx("meta", {
          property: "og:description",
          content: "Turn your one day into day one."
        }), /*#__PURE__*/_jsx("meta", {
          property: "og:url",
          content: "http://subkit.com/"
        }), /*#__PURE__*/_jsx("meta", {
          property: "og:image",
          content: "https://subkit-images.s3.us-east-1.amazonaws.com/subkit-logos-images/subkit_background.png"
        }), /*#__PURE__*/_jsx("meta", {
          property: "twitter:card",
          content: "summary_large_image"
        }), /*#__PURE__*/_jsx("meta", {
          property: "twitter:title",
          content: "Subkit"
        }), /*#__PURE__*/_jsx("meta", {
          property: "twitter:description",
          content: "Turn your one day into day one."
        }), /*#__PURE__*/_jsx("meta", {
          property: "twitter:image:alt",
          content: "Turn your one day into day one."
        }), /*#__PURE__*/_jsx("meta", {
          property: "twitter:url",
          content: "http://subkit.com/"
        }), /*#__PURE__*/_jsx("meta", {
          property: "twitter:image",
          content: "https://subkit-images.s3.us-east-1.amazonaws.com/subkit-logos-images/subkit_background.png"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: classNames('flex flex-col prospect-page-container w-full justify-center', {
          'md:w-1/2': !emailSent,
          'items-center': emailSent
        }),
        children: /*#__PURE__*/_jsx("div", {
          className: classNames('px2 flex flex-column prospect-page-left-wrapper', {
            'email-sent': emailSent,
            'lg:w-3/4': !emailSent
          }),
          style: {
            width: emailSent && '395px'
          },
          children: emailSent ? /*#__PURE__*/_jsx(Information, {
            heading: "Turn your \u201Cone day\u201D into day one.",
            subHeading: "You\u2019re almost there",
            body: "Check your email to confirm your username and we'll let you know when we launch.",
            classes: {
              container: classNames('flex flex-column justify-start flex-auto prospect-information-wrapper')
            }
          }) : /*#__PURE__*/_jsx(ProspectForm, {
            saveProspect: submitProspect,
            parentFeedback: feedback,
            handleFeedback: handleFeedback
          })
        })
      }), emailSent ? /*#__PURE__*/_jsx("div", {
        className: "prospect-page-right-wrapper email-sent self-center px-6 md:px-2",
        children: /*#__PURE__*/_jsx("img", {
          src: "https://subkit-images.s3.amazonaws.com/images/mailbox.svg",
          alt: "Mailbox",
          className: "illustration inverted"
        })
      }) : /*#__PURE__*/_jsx("div", {
        className: "prospect-page-right-wrapper email-not-sent self-center px-6 md:px-2",
        children: /*#__PURE__*/_jsx("img", {
          src: "https://subkit-images.s3.amazonaws.com/images/woman-laptop.svg",
          alt: "Woman with laptop",
          className: "illustration"
        })
      })]
    })]
  });
};